// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\r\n  <path d=\"M60 0C26.914 0 0 26.914 0 60v392c0 33.085 26.914 60 60 60h392c33.085 0 60-26.915 60-60V60c0-33.086-26.915-60-60-60zm380 230v50H70v-50z\"/>\r\n</svg>\r\n";
// Exports
module.exports = code;